// @ts-nocheck
import React from 'react';
import GenericError from './GenericError';

export const Forbidden = () => {
  return (
    <GenericError
      title={'403: Forbidden'}
      description={`You don't have permissions to access this page.`}
      imgSrc={`/static/images/undraw_close_tab_uk6g.svg`}
    />
  );
};

export default Forbidden;
